let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9JOIG")).then(() => parcelRequire('f4oZQ'));